export const REFERRAL_BANNER = 'referral-banner'
export const PROMO_BANNER = 'active-promo-banner'
